import { Link } from 'react-router-dom';
import { ROUTES, PHONE, WHATSAPP, EMAIL, ADDRESS } from '@/lib/constants';

const serviceLinks = [
  { label: 'Cuisines MDF', href: ROUTES.SERVICES.CUISINE_MDF },
  { label: 'Cuisines Modernes', href: ROUTES.SERVICES.CUISINE_MODERNE },
  { label: 'Cuisines Sur Mesure', href: ROUTES.SERVICES.CUISINE_SUR_MESURE },
  { label: 'Placards & Dressings', href: ROUTES.SERVICES.PLACARD_DRESSING },
  { label: 'Cuisines Équipées', href: ROUTES.SERVICES.CUISINE_EQUIPEE },
];

const blogCategories = [
  { label: 'Cuisines MDF', href: `${ROUTES.BLOG}?cat=mdf` },
  { label: 'Cuisines Modernes', href: `${ROUTES.BLOG}?cat=moderne` },
  { label: 'Conseils & Prix', href: `${ROUTES.BLOG}?cat=conseils` },
  { label: 'Entretien', href: `${ROUTES.BLOG}?cat=entretien` },
  { label: 'Placards & Rangements', href: `${ROUTES.BLOG}?cat=placard` },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main footer */}
      <div className="container mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <Link to={ROUTES.HOME} className="flex items-center gap-2 mb-4">
            <svg viewBox="0 0 40 40" className="w-9 h-9" aria-hidden="true">
              <rect width="40" height="40" rx="8" fill="#B45309" />
              <path d="M8 28 L20 10 L32 28 Z" fill="white" opacity="0.9" />
              <rect x="14" y="22" width="12" height="7" rx="1" fill="#B45309" />
            </svg>
            <span className="font-bold text-white text-lg">Cuisine MDF Agadir</span>
          </Link>
          <p className="text-sm leading-relaxed mb-4">
            Spécialiste de la cuisine sur mesure à Agadir depuis plus de 15 ans. Fabricant et poseur de cuisines MDF, modernes, équipées et placards haut de gamme.
          </p>
          <div className="flex gap-3">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-9 h-9 bg-gray-700 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors"
            >
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 bg-gray-700 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors"
            >
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" fill="none" stroke="currentColor" strokeWidth="2"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="currentColor" strokeWidth="2"/></svg>
            </a>
            <a
              href={`https://wa.me/${WHATSAPP}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="w-9 h-9 bg-gray-700 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors"
            >
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
            </a>
          </div>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Nos Services</h3>
          <ul className="space-y-2">
            {serviceLinks.map((l) => (
              <li key={l.href}>
                <Link to={l.href} className="text-sm hover:text-amber-400 transition-colors flex items-center gap-1">
                  <span className="text-amber-600">›</span> {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Blog */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Articles du Blog</h3>
          <ul className="space-y-2">
            {blogCategories.map((l) => (
              <li key={l.href}>
                <Link to={l.href} className="text-sm hover:text-amber-400 transition-colors flex items-center gap-1">
                  <span className="text-amber-600">›</span> {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to={ROUTES.BLOG} className="text-sm text-amber-400 hover:underline">
                Voir tous les articles →
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <svg className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              <span>{ADDRESS}</span>
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-amber-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              <a href={`tel:${PHONE.replace(/\s|-/g,'')}`} className="hover:text-amber-400">{PHONE}</a>
            </li>
            <li className="flex items-center gap-2">
              <svg className="w-4 h-4 text-amber-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              <a href={`mailto:${EMAIL}`} className="hover:text-amber-400">{EMAIL}</a>
            </li>
            <li className="mt-4">
              <Link to={ROUTES.CONTACT} className="inline-block bg-amber-600 text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-amber-700 transition-colors">
                Demander un devis
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <p>© {year} Cuisine MDF Agadir. Tous droits réservés.</p>
          <div className="flex gap-4">
            <Link to="/mentions-legales" className="hover:text-gray-300">Mentions légales</Link>
            <Link to="/politique-confidentialite" className="hover:text-gray-300">Confidentialité</Link>
            <Link to={ROUTES.SITEMAP} className="hover:text-gray-300">Plan du site</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
